/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Status_PublishedInputs */

const en_admin_posts_status_published = /** @type {(inputs: Admin_Posts_Status_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published`)
};

const zh_admin_posts_status_published = /** @type {(inputs: Admin_Posts_Status_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已发布`)
};

/**
* | output |
* | --- |
* | "Published" |
*
* @param {Admin_Posts_Status_PublishedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_status_published = /** @type {((inputs?: Admin_Posts_Status_PublishedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Status_PublishedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_status_published(inputs)
	return zh_admin_posts_status_published(inputs)
});
export { admin_posts_status_published as "admin.posts.status_published" }